// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_UQFt9 {
  margin-bottom: 32px;
}

.title_IG0tO {
  font-size: 16px;
  font-weight: 600;
  color: #222222;
  margin: 0 0 16px 0;
}

.optionsContainer__lk9r {
  display: flex;
  gap: 12px;
}

.option_fW6CB {
  flex: 1 1;
  padding: 16px 16px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  background: #FFFFFF;
  color: #364153;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.option_fW6CB:hover {
  border-color: #D1D5DB;
  background: #F9FAFB;
}

.option_fW6CB.selected_zjIY3 {
  background: #EAEAEF;
  border-color: transparent;
  color: #4F5660;
} `, "",{"version":3,"sources":["webpack://./src/factura-customizer/components/CornersStyle/CornersStyle.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".container {\n  margin-bottom: 32px;\n}\n\n.title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #222222;\n  margin: 0 0 16px 0;\n}\n\n.optionsContainer {\n  display: flex;\n  gap: 12px;\n}\n\n.option {\n  flex: 1;\n  padding: 16px 16px;\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  background: #FFFFFF;\n  color: #364153;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.option:hover {\n  border-color: #D1D5DB;\n  background: #F9FAFB;\n}\n\n.option.selected {\n  background: #EAEAEF;\n  border-color: transparent;\n  color: #4F5660;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_UQFt9`,
	"title": `title_IG0tO`,
	"optionsContainer": `optionsContainer__lk9r`,
	"option": `option_fW6CB`,
	"selected": `selected_zjIY3`
};
export default ___CSS_LOADER_EXPORT___;
